import React, { useRef } from "react";
import styled from "styled-components";

import { Tooltip } from "./Tooltip";

interface EllipsizedTextProps {
  className?: string;
  text?: string;
  renderPrefixSpace?: boolean;
}

const Wrap = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EllipsizedText = ({ className, text, renderPrefixSpace }: EllipsizedTextProps) => {
  const divRef = useRef<HTMLDivElement>(null);

  const tooltip =
    text && (divRef.current?.scrollWidth ?? 0) > (divRef.current?.offsetWidth ?? 0)
      ? text.trimStart()
      : "";

  if (!text) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <Wrap
        className={className}
        ref={divRef}
        title={renderPrefixSpace ? "" : text.trimStart()}
        style={{ whiteSpace: renderPrefixSpace ? "pre" : "nowrap" }}
      >
        {text}
      </Wrap>
    </Tooltip>
  );
};
